export const GENERAL_NS = "General";

export const i18n = {
  en: {
    copyright: "All rights reserved. Copyright © {{year}} ADP Clear",
    privacyPolicy: "Privacy Policy | Terms & Conditions",
  },
};
